import { EXT_PUSHER_UPDATE_CONNECTIONS, EXT_PUSHER_UPDATE_JOBS, EXT_PUSHER_UPLOAD_STATUS } from "./types"

export const ExtUpdateConnections = (data) => {
    return {
        type: EXT_PUSHER_UPDATE_CONNECTIONS,
        payload: data
    }
}

export const ExtUpdateJobs = (data) => {
    return {
        type: EXT_PUSHER_UPDATE_JOBS,
        payload: data
    }
}

export const ExtUploadStatus = (data) => {
    return {
        type: EXT_PUSHER_UPLOAD_STATUS,
        payload: data
    }
}